// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "recommendations-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"1d0b3daaf7a76d0a1972","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"77bc46a78cfa885b6f8d","vendors-node_modules_rehype-highlight_index_js":"d0bba19fc6d463e6deda"}[chunkId] + "";
};